var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormatColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.286 17.143H18.24L12.405.968C12.208.39 11.665 0 11.053 0H8.947c-.611 0-1.155.39-1.352.968L1.759 17.143H.714c-.394 0-.714.32-.714.714v1.429c0 .394.32.714.714.714H6.43c.394 0 .714-.32.714-.714v-1.429c0-.394-.32-.714-.714-.714h-.875l1.04-2.857h6.811l1.04 2.857h-.874c-.394 0-.714.32-.714.714v1.429c0 .394.32.714.714.714h5.715c.394 0 .714-.32.714-.714v-1.429c0-.394-.32-.714-.714-.714zm-11.39-6.429L10 4.934l2.105 5.78h-4.21z",
    transform: "translate(2 2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormatColor);
export default __webpack_public_path__ + "static/media/format-color.73484d0d5cd84f8af038b050b1f74473.svg";
export { ForwardRef as ReactComponent };